import type { GetObligationAuditByIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetObligationAuditByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetObligationAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetObligationAuditByIdArgs = { id: string };

export const useGetObligationAuditById = createQueryHook<
  UseGetObligationAuditByIdArgs,
  GetObligationAuditByIdResponseRow[],
  GetObligationAuditByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getObligationAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ obligation_audit: data }),
  graphqlDocument: GetObligationAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
